"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInput = exports.getOptionsFiltered = exports.generateIOptionValue = exports.SearchChangeReason = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var TypographyColor_1 = require("../../enums/TypographyColor");
var InputField_1 = require("../InputField/InputField");
var SearchInput_style_1 = require("./SearchInput.style");
var Search_1 = tslib_1.__importDefault(require("@material-ui/icons/Search"));
var core_1 = require("@material-ui/core");
var Autocomplete_1 = tslib_1.__importDefault(require("@material-ui/lab/Autocomplete/Autocomplete"));
var _colors_1 = require("../../../style/commons/_colors");
var SearchChangeReason;
(function (SearchChangeReason) {
    SearchChangeReason["CreateOption"] = "create-option";
    SearchChangeReason["SelectOption"] = "select-option";
    SearchChangeReason["RemoveOption"] = "remove-option";
    SearchChangeReason["Clear"] = "clear";
    SearchChangeReason["Reset"] = "reset";
    SearchChangeReason["Blur"] = "blur";
})(SearchChangeReason = exports.SearchChangeReason || (exports.SearchChangeReason = {}));
var generateIOptionValue = function (value) {
    if (typeof value === 'string') {
        return { label: value };
    }
    return value;
};
exports.generateIOptionValue = generateIOptionValue;
var getOptionsFiltered = function (options, value, maxOptionsToShow) {
    var optionsFiltered = options.filter(function (option) {
        var optionLabel = option.label.toLowerCase();
        var valueLabelToCompare = value.label.toLowerCase();
        return optionLabel.indexOf(valueLabelToCompare) !== -1;
    });
    return maxOptionsToShow ? optionsFiltered.slice(0, maxOptionsToShow) : optionsFiltered;
};
exports.getOptionsFiltered = getOptionsFiltered;
var DEFAULT_MAX_LENGTH = 9999;
var SearchInput = function (_a) {
    var name = _a.name, placeholder = _a.placeholder, options = _a.options, _b = _a.value, value = _b === void 0 ? '' : _b, validation = _a.validation, disabled = _a.disabled, _c = _a.maxLength, maxLength = _c === void 0 ? DEFAULT_MAX_LENGTH : _c, onChange = _a.onChange, onBlur = _a.onBlur, _d = _a.showIcon, showIcon = _d === void 0 ? false : _d, _e = _a.disableChromeAutofill, disableChromeAutofill = _e === void 0 ? false : _e, _f = _a.maxOptionsToShow, maxOptionsToShow = _f === void 0 ? undefined : _f;
    var classes = (0, SearchInput_style_1.useSearchInputStyles)();
    var DOT_SEPARATOR = '·';
    var onInputChangeHandler = function (event, inputValue) {
        onChange && onChange(event, { label: inputValue });
    };
    var onChangeHandler = function (event, inputValue, reason) {
        onChange && onChange(event, { label: inputValue !== null && inputValue !== void 0 ? inputValue : '' }, reason);
    };
    var renderOption = function (option) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(core_1.Typography, { variant: "body2", noWrap: true, color: TypographyColor_1.TypographyColor.primary },
                option.label,
                "\u00A0"),
            option.description && (react_1.default.createElement(core_1.Typography, { variant: "body2", noWrap: true, color: TypographyColor_1.TypographyColor.textPrimary }, "".concat(DOT_SEPARATOR, " ").concat(option.description)))));
    };
    var valueToRender = (0, exports.generateIOptionValue)(value);
    return (react_1.default.createElement(Autocomplete_1.default, { id: "autocomplete-".concat(name), freeSolo: true, classes: {
            inputRoot: classes.inputRoot,
            input: classes.input,
            paper: classes.paper,
            option: classes.option,
            listbox: classes.options,
            clearIndicator: classes.clear,
        }, onChange: onChangeHandler, onInputChange: onInputChangeHandler, options: (0, exports.getOptionsFiltered)(options, valueToRender, maxOptionsToShow), getOptionLabel: function (option) { return option.label.toString(); }, renderOption: renderOption, inputValue: valueToRender.label, value: valueToRender, renderInput: function (params) { return (react_1.default.createElement(InputField_1.InputField, tslib_1.__assign({}, params, { name: disableChromeAutofill ? '' : name, placeholder: placeholder, value: valueToRender.label, type: InputField_1.InputType.Text, validation: validation, disabled: disabled, onBlur: onBlur, maxLength: maxLength, startIcon: showIcon && react_1.default.createElement(Search_1.default, { style: { color: _colors_1.darkPrimary } }), autoComplete: disableChromeAutofill ? 'new-password' : 'off' }))); } }));
};
exports.SearchInput = SearchInput;
